var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-page"},[_c(_vm.reportType === 'member' ? 'member-report' : 'summary-report',{tag:"component",attrs:{"reportType":_vm.reportType},on:{"typeChange":_vm.handleTypeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }